export const openTransferDialog = () => ({
    type: 'TRANSFER_DIALOG__OPEN',
});
export const close_transfer_dialog = () => ({
    type: 'TRANSFER_DIALOG__CLOSE',
});
export const transfer_device = (new_user_login, transfer_device_id, clear_access, clear_data) => async (dispatch, getState, { api }) => {
    dispatch({
        type: 'TRANSFER_DEVICE__REQUEST',
        new_user_login,
        transfer_device_id,
        clear_access,
        clear_data,
    });
    try {
        await api.transfer_device(transfer_device_id, new_user_login, clear_access, clear_data);
        dispatch({
            type: 'TRANSFER_DEVICE__OK',
            new_user_login,
            transfer_device_id,
            clear_access,
            clear_data,
        });
        dispatch({ type: 'DEVICE_DELETED', device_id: transfer_device_id });
    }
    catch (error) {
        dispatch({
            type: 'TRANSFER_DEVICE__FAIL',
            new_user_login,
            transfer_device_id,
            clear_access,
            clear_data,
            error: error?.json?.error_ui ??
                error?.json?.error ??
                'Не удалось отправить запрос',
        });
    }
};
